"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _EqualSizeGrid = _interopRequireDefault(require("../layout-wrappers/EqualSizeGrid"));
var _InfoPanel = _interopRequireDefault(require("../layout-wrappers/InfoPanel"));
var _helpers = require("../../utils/helpers");
var _settings = require("../../settings");
require("../../scss/layouts/BasicGridModule.module.scss");
function BasicGridModule(_ref) {
  let {
    children,
    gap = '1.5rem',
    itemsPerRow = 4,
    classname = '',
    title = '',
    infoPanel,
    itemComponent = {
      layout: 'ImageCard',
      props: {
        fullCardClickable: false
      }
    },
    infoPanelComponent = {
      layout: "",
      backButtonLabel: "Return to List",
      resourceList: [],
      classname: ''
    },
    items = [],
    customClicksHandler = null,
    noAnimation = false
  } = _ref;
  const [infoPanelOpen, setInfoPanelOpen] = (0, _react.useState)(false);
  const [infoPanelContent, setInfoPanelContent] = (0, _react.useState)({});
  const [Child, setChild] = (0, _react.useState)(null);
  const [state, setState] = (0, _react.useState)("entering");
  const [firstEntry, setFirstEntry] = (0, _react.useState)(noAnimation ? null : true);
  const stateRef = (0, _react.useRef)('entering');
  const gridRef = (0, _react.useRef)(null);
  const handleAnimationEnd = (0, _react.useCallback)(() => {
    gridRef.current.children[0].addEventListener('animationstart', () => {
      gridRef.current.children[0].addEventListener('animationend', handleAnimationEnd, {
        once: true
      });
    });
    if (stateRef.current === 'exiting') {
      setState('entering');
      stateRef.current = 'entering';
      setInfoPanelOpen(true);
    } else {
      setState('idle');
    }
  }, []);
  const defaultHandleClicks = eventDetails => {
    if (eventDetails.type === 'info-panel') {
      setInfoPanelContent(infoPanelComponent.resourceList.find(item => Number.parseInt(item.id, 10) === Number.parseInt(eventDetails.resourceId, 10)));
      setFirstEntry(false);
      stateRef.current = 'exiting';
      setState('exiting');
    }
  };
  (0, _react.useEffect)(() => {
    // load the layout component used for this slide
    setChild(_settings.blockLayoutsMap.get(itemComponent.layout));
  }, [itemComponent.layout]);
  (0, _react.useEffect)(() => {
    if (!infoPanelOpen && gridRef.current !== null) {
      var _gridRef$current;
      if ((_gridRef$current = gridRef.current) !== null && _gridRef$current !== void 0 && _gridRef$current.children) {
        // window.scrollTo({
        //     // need to use child offset because the grid ref is set to 
        //     // display: contents
        //     top: gridRef.current?.children[0]?.offsetTop - 24,
        //     left: 0,
        //     behavior: 'instant',
        // })
      }
      if (gridRef.current.children.length) {
        var _gridRef$current$chil, _gridRef$current$chil2;
        (_gridRef$current$chil = gridRef.current.children[0]) === null || _gridRef$current$chil === void 0 || _gridRef$current$chil.removeEventListener('animationend', handleAnimationEnd, {
          once: true
        });
        (_gridRef$current$chil2 = gridRef.current.children[0]) === null || _gridRef$current$chil2 === void 0 || _gridRef$current$chil2.addEventListener('animationend', handleAnimationEnd, {
          once: true
        });
      }
    }
  }, [infoPanelOpen, handleAnimationEnd]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !infoPanelOpen && /*#__PURE__*/_react.default.createElement("basic-grid-module", {
    "data-state": state,
    "first-entry": firstEntry,
    ref: gridRef
  }, title !== '' && /*#__PURE__*/_react.default.createElement("h2", {
    className: (0, _helpers.classes)(['basic-grid-module__header', 'h4'])
  }, title), Child !== null && /*#__PURE__*/_react.default.createElement(_EqualSizeGrid.default, {
    gap: gap,
    itemsPerRow: itemsPerRow,
    classname: classname
  }, items.map(item => /*#__PURE__*/_react.default.createElement(Child, (0, _extends2.default)({}, item, itemComponent.props, {
    relatedResourceId: item.id,
    handleClicks: customClicksHandler !== null && customClicksHandler !== void 0 ? customClicksHandler : defaultHandleClicks,
    key: "grid-item-".concat(Math.round(Math.random() * 10000000))
  }))))), infoPanelOpen && infoPanelComponent.layout && /*#__PURE__*/_react.default.createElement(_InfoPanel.default, {
    className: "grid-info-panel",
    onBackClicked: () => {
      setInfoPanelOpen(false);
    },
    backButtonLabel: infoPanelComponent.backButtonLabel,
    layoutComponent: {
      layout: infoPanelComponent.layout,
      props: {
        ...infoPanelContent
      }
    },
    classname: infoPanelComponent.classname
  }));
}
var _default = exports.default = BasicGridModule;